import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import Component from '../Component'
import { getTeamUrl } from 'Common'
import fetchServiceTypes from '../.././../Core/Services/fetchServiceTypes'
import fetchUserSettings from '../.././../Core/Services/fetchUserSettings'
import {
  handleFetchDashboard,
  handleFetchActiveRams,
  handleFetchSettings,
  handleFetchProjectsList,
  handleTableChange,
  handleProjectFilterChange,
  handleStatusFilterChange,
  handleFetchDocuments,
  handleUploadDocument,
  handleDeleteDocument,
  handleToggleDocumentActive,
} from '../Handlers'

var mapStateToProps = function(state) {
  return {
    dashboard: state.screens.RamsControlCentre.dashboard.data,
    dashboardLoading: state.screens.RamsControlCentre.dashboard.fetching,
    activeRams: state.screens.RamsControlCentre.active.data,
    activeRamsLoading: state.screens.RamsControlCentre.active.fetching,
    pagination: state.screens.RamsControlCentre.active.pagination,
    settings: state.screens.RamsControlCentre.settings.data,
    settingsLoading: state.screens.RamsControlCentre.settings.fetching,
    projectsList: state.screens.RamsControlCentre.projectsList.data,
    serviceTypes: state.core.serviceTypes,
    userSettings: state.core.userSettings,
    documents: state.screens.RamsControlCentre.documents.data,
    documentsLoading: state.screens.RamsControlCentre.documents.fetching,
    documentsUploading: state.screens.RamsControlCentre.documents.uploading,
  }
}

var mapDispatchToProps = function(dispatch) {
  return {
    componentDidMount: function() {
      dispatch(handleFetchDashboard())
      dispatch(handleFetchActiveRams({ page: 1, per_page: 20 }))
      dispatch(handleFetchSettings())
      dispatch(handleFetchProjectsList())
      dispatch(fetchServiceTypes())
      dispatch(fetchUserSettings())
    },
    onChangeTable: function(pagination, filters, sorter) {
      dispatch(handleTableChange(pagination, filters, sorter))
    },
    onProjectFilterChange: function(projectId) {
      dispatch(handleProjectFilterChange(projectId))
    },
    onStatusFilterChange: function(status) {
      dispatch(handleStatusFilterChange(status))
    },
    onRefreshActive: function() {
      dispatch(handleFetchDashboard())
      dispatch(handleFetchActiveRams({ page: 1, per_page: 20 }))
    },
    onClickSettings: function() {
      dispatch(push(getTeamUrl('settings?group=RAMS')))
    },
    onFetchDocuments: function() {
      dispatch(handleFetchDocuments())
    },
    onUploadDocument: function(formData) {
      return dispatch(handleUploadDocument(formData))
    },
    onDeleteDocument: function(id) {
      return dispatch(handleDeleteDocument(id))
    },
    onToggleDocumentActive: function(id) {
      return dispatch(handleToggleDocumentActive(id))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
